module.exports = __webpack_public_path__ + "img/camara_courier.1eec122a.svg";